"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreButton = _interopRequireDefault(require("@legacy-vfuk/core-button"));

var _coreHeading = _interopRequireDefault(require("@legacy-vfuk/core-heading"));

var _coreParagraph = _interopRequireDefault(require("@legacy-vfuk/core-paragraph"));

var _corePill = _interopRequireDefault(require("@legacy-vfuk/core-pill"));

var _reactI18next = require("react-i18next");

var _loadResources = _interopRequireDefault(require("@legacy-vfuk/core-language-packs/dist/utils/loadResources"));

var _RadioFilter = _interopRequireDefault(require("./components/RadioFilter"));

var _CheckboxFilter = _interopRequireDefault(require("./components/CheckboxFilter"));

var _ToggleFilter = _interopRequireDefault(require("./components/ToggleFilter"));

var Styled = _interopRequireWildcard(require("./styles/FilterFlyout.style"));

var _locales = _interopRequireWildcard(require("./locales"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FilterFlyout = function FilterFlyout(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Filters' : _ref$title,
      _ref$numberOfActiveFi = _ref.numberOfActiveFilters,
      numberOfActiveFilters = _ref$numberOfActiveFi === void 0 ? 0 : _ref$numberOfActiveFi,
      subText = _ref.subText,
      filters = _ref.filters,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      onClose = _ref.onClose;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var memoizedResources = (0, _react.useCallback)(function () {
    return (0, _loadResources["default"])(i18n, _locales.componentName, _locales["default"]);
  }, [i18n, _locales.componentName, _locales["default"]]);
  memoizedResources();
  return /*#__PURE__*/_react["default"].createElement(Styled.FilterFlyout, null, /*#__PURE__*/_react["default"].createElement(Styled.Header, null, /*#__PURE__*/_react["default"].createElement(Styled.HeadingWrapper, {
    hasSubText: !!subText
  }, /*#__PURE__*/_react["default"].createElement(_coreHeading["default"], {
    text: title,
    size: 2,
    noMargin: true,
    weight: 3
  }), numberOfActiveFilters > 0 ? /*#__PURE__*/_react["default"].createElement(_corePill["default"], {
    text: "".concat(numberOfActiveFilters)
  }) : null), subText ? /*#__PURE__*/_react["default"].createElement(_coreParagraph["default"], null, subText) : null), /*#__PURE__*/_react["default"].createElement(Styled.Sections, null, filters.map(function (filter, index) {
    switch (filter.type) {
      case 'radio':
        return /*#__PURE__*/_react["default"].createElement(_RadioFilter["default"], {
          key: index,
          title: filter.title,
          id: filter.id,
          subText: filter.subText,
          options: filter.options,
          checked: filter.checked,
          items: filter.items,
          showReset: filters.length > 1 && !!filter.checked,
          onChange: onChange
        });

      case 'checkbox':
        return /*#__PURE__*/_react["default"].createElement(_CheckboxFilter["default"], {
          key: index,
          title: filter.title,
          id: filter.id,
          subText: filter.subText,
          options: filter.options,
          items: filter.items,
          onChange: onChange
        });

      case 'toggle':
        return /*#__PURE__*/_react["default"].createElement(_ToggleFilter["default"], {
          key: index,
          title: filter.title,
          id: filter.id,
          subText: filter.subText,
          items: filter.items,
          onChange: onChange,
          disableCollapse: filter.disableCollapse
        });

      default:
        return null;
    }
  })), /*#__PURE__*/_react["default"].createElement(Styled.Footer, null, /*#__PURE__*/_react["default"].createElement(_coreButton["default"], {
    appearance: "alt1",
    text: t('Clear all'),
    onClick: onClear
  }), /*#__PURE__*/_react["default"].createElement(_coreButton["default"], {
    text: t('Apply'),
    onClick: onClose
  })));
};

FilterFlyout.displayName = "FilterFlyout";

var _default = /*#__PURE__*/(0, _react.memo)(FilterFlyout);

exports["default"] = _default;
//# sourceMappingURL=FilterFlyout.js.map